<template>
  <div
    id="ghl-chat-widget-wrapper"
    data-chat-widget
    data-widget-id="6a2da9ea9cb8f1e129c900c0"
    data-location-id="H7PiIYJwsHXBFNLf4IHQ"
  ></div>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { assistant } = storeToRefs(store)

function LoadGhlScript() {
  const existingScript = document.getElementById('ghl-leadconnector-loader')
  if (!existingScript) {
    const script = document.createElement('script')
    script.id = 'ghl-leadconnector-loader'
    script.src = 'https://widgets.leadconnectorhq.com/loader.js'
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js')
    script.setAttribute('data-widget-id', '6a2da9ea9cb8f1e129c900c0')
    script.async = true
    document.body.appendChild(script)
  }
}

function OpenGhlChat() {
  // GHL creates a custom element <chat-widget> with shadowRoot or an iframe/button
  const chatWidget = document.querySelector('chat-widget') as any
  if (chatWidget) {
    // If GHL exposes open method or shadowRoot button
    if (typeof chatWidget.open === 'function') {
      chatWidget.open()
    } else if (chatWidget.shadowRoot) {
      const launcherBtn = chatWidget.shadowRoot.querySelector('button, .chat-widget-button, #chat-widget-button') as HTMLElement
      if (launcherBtn) launcherBtn.click()
    }
  } else {
    // Fallback trigger click on any LeadConnector launcher element
    const launcher = document.querySelector('.leadconnector-chat-launcher, [data-chat-widget-button]') as HTMLElement
    if (launcher) launcher.click()
  }
}

watch(() => assistant.value.visible, (newVal) => {
  if (newVal) {
    OpenGhlChat()
    // Reset store visible flag so it can be re-triggered
    assistant.value.visible = false
  }
})

onMounted(() => {
  LoadGhlScript()
})
</script>

<style>
/* Ensure LeadConnector floating launcher is always above other elements */
chat-widget, .chat-widget-container, #chat-widget-container {
  z-index: 99999 !important;
}
</style>
